/**
 * @file scroll.js
 * @description 滚动事件-装饰器
 */

import scrollToId from './scrollToId';
import {notAllowScroll, allowScroll, preventDefault} from './scrollAllow';
import {getScrollTop, getScrollHeight, getWindowHeight, getOffsetTop} from './scrollTop';

export {
    scrollToId,
    notAllowScroll,
    allowScroll,
    preventDefault,
    getScrollTop,
    getScrollHeight,
    getWindowHeight,
    getOffsetTop
};
